/* eslint-disable consistent-return */
import has from 'lodash/has'
import { buildRouteFromPath } from '../../shared/helpers/route-helper'
import { BROWSE_STORES_WITH_CAT } from '../../shared/paths'
import { CENTRE_SERVICES } from '../../shared/helpers/templates'
import { slugify } from '../helpers'
import analyticsUtils from '../../shared/helpers/analytics-utils'

export default (callToAction, centre, collectionEntryType, templatePath) => {
  if (has(callToAction, 'category.value')) {
    const { category, subCategory } = callToAction
    const storeCat = slugify(category.value)
    const storeSubCat = subCategory.value && slugify(subCategory.value)
    return {
      category: 'Stores',
      eventCategory: analyticsUtils.events.MODULE_IMPRESSION,
      eventAction: analyticsUtils.categories.SPOTLIGHT_CTA,
      eventLabel: analyticsUtils.actions.STORES_SEE_MORE,
      address: buildRouteFromPath(BROWSE_STORES_WITH_CAT, {
        centre,
        storeCat,
        storeSubCat,
      }),
      text: 'See More',
    }
  }

  if (has(callToAction, 'newsCallToActionUrl')) {
    let newsCallToActionUrl = null
    try {
      newsCallToActionUrl = new URL(callToAction.newsCallToActionUrl)
      newsCallToActionUrl = newsCallToActionUrl.href
        .replace(newsCallToActionUrl.origin, '')
        .slice(1)
    } catch (e) {
      /*
       * 'Call to Action' button will not be
       * present when component renders
       */
    }
    return {
      eventCategory: analyticsUtils.events.MODULE_IMPRESSION,
      eventAction: analyticsUtils.categories.NEWS_CTA,
      eventLabel: analyticsUtils.actions.NEWS_SEE_MORE,
      ...(newsCallToActionUrl && { address: newsCallToActionUrl }),
      text: analyticsUtils.actions.NEWS_SEE_MORE,
    }
  }
  /* if spotlight is of type service and template path is not centre-services
    then set the object to display button */

  if (templatePath !== CENTRE_SERVICES && collectionEntryType === 'service') {
    return {
      address: `/${centre}/${CENTRE_SERVICES}`,
      text: 'See all services',
    }
  }
}
